import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Link } from '../../interfaces/link.interface';
import { Schedule } from '../../interfaces/schedule.interface';
import DataSource from 'devextreme/data/data_source';
import { AsamcoAuthService, AsamcoUserService } from '@asamco/base';
import { dateByMinutesOffset, pathJoin, showErrorSwal } from '@asamco/utils';
import { SchedulerDays, SchedulerExpiration, SchedulerPeriodicity } from '../../enums/scheduler-types.enum';
import { SchedulerService } from '../../services/scheduler.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { BehaviorSubject, combineLatest, Observable, of, ReplaySubject, Subject, throwError } from 'rxjs';
import ODataStore from 'devextreme/data/odata/store';
import { cwd } from 'process';
import { DxSchedulerComponent, DxTextBoxModule, DxListModule, DxSwitchModule, DxSchedulerModule } from 'devextreme-angular';
import Swal from 'sweetalert2';
import { map, switchMap, take, takeUntil } from 'rxjs/operators';
import { LinkEditSchedulerFormComponent } from './link-edit-scheduler-form/link-edit-scheduler-form.component';
import { JobStatus, JobStatusCode } from '../../enums/job-status.enum';
import { data } from 'currency-codes';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { AlCompanyService } from '../../services/al-company.service';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { LinkService } from '../../services/link.service';
import CustomStore from 'devextreme/data/custom_store';
import { LinkSchedulerInformation } from '../../interfaces/link-scheduler-information.interface';
import { LinkSchedulerCreateObject } from '../../interfaces/link-scheduler-create-object.interface';
import { UserConfigService } from '../../services/user-config.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'al-link-edit-schedular',
    templateUrl: './link-edit-schedular.component.html',
    styleUrls: ['./link-edit-schedular.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        DxTextBoxModule,
        DxListModule,
        DxTemplateModule,
        DxSwitchModule,
        LinkEditSchedulerFormComponent,
        DxSchedulerModule,
        AsyncPipe,
    ],
})
export class LinkEditSchedularComponent implements OnInit, OnDestroy {


	@ViewChild(LinkEditSchedulerFormComponent)
	formModal: LinkEditSchedulerFormComponent;

	@Input()
	linkInfo: MarketPlaceItem;
	/** The link to edit */
	/** Retrieves the latest link item (for example when switching between pages by ID) */
	@Input()
	set link(link: Link) {
		this.usableLink = link;
	}

	currentDate: Date = new Date(Date.now());

	appointments: any[] = []
	private readonly destroy$ = new Subject<void>();
	public store: CustomStore;
	public linkSchedulerInformation: LinkSchedulerInformation;

	public usableLink: Link;
	jobSource: DataSource;
	public isSchedulerEnabled: boolean = false;
	public isSchedulerEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public now: Date = new Date();
	form: any;

	//User config
	userConfig: any = {};

	schedulerDisabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	companyTimezone$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

	public listOfNextExecutionDate$: BehaviorSubject<Date[]> = new BehaviorSubject<Date[]>([]);

	constructor(private schedulerService: SchedulerService, private companyService: AlCompanyService, private selectedCompanyService: SelectedCompanyService, private linkService: LinkService, private cdr: ChangeDetectorRef, private userConfigService: UserConfigService) {

	}

	onAppointmentClick($event: any)
	{
		$event.cancel = true;
	}

	onAppointmentRendered($event: { appointmentElement: HTMLElement; appointmentData: any }) {
		//Special color for current link
		if($event.appointmentData.linkId == this.usableLink.id)
		{
			$event.appointmentElement.style.backgroundColor = '#FFA500'
		}
		else
		{
			$event.appointmentElement.style.backgroundColor = '#eabc6b'
		}
	}

	enableSchedulerButton($event: any) {
		this.cdr.detectChanges();
	}

	gridDisplayAllSwitchValueChanged($event: any) {
		this.userConfig.showAllLinkSchedules = $event.value;
		this.userConfigService.setConfig(this.userConfig);
		this.setupOData();
	}

	saveSchedulerConfiguration() {
		const linkSchedulerDto = {} as LinkSchedulerCreateObject;

		linkSchedulerDto.linkId = this.usableLink.id;

		if (this.isSchedulerEnabled) {
			let data = this.formModal.getSchedulerConfiguration();
			linkSchedulerDto.isSchedulerEnabled = true;
			linkSchedulerDto.startDate = data.startDate;
			if (data.isRecurring) {
				linkSchedulerDto.recurrenceRules = this.formModal.getICALRecurrenceRule();
			}
		}

		// const linkSchedulerDto = {} as LinkSchedulerCreateObject;

		this.schedulerService.addScheduleInfo(linkSchedulerDto).subscribe(_ => {
			Swal.fire({
				title: 'Succesfully updated schedule',
				timer: 3000,
				icon: 'success',
			});


			this.setupOData();
		});


	}

	getListOfDates() {
		this.schedulerService.getNextExecutionDates(this.usableLink.id).subscribe(listOfDates => {
			this.listOfNextExecutionDate$.next(listOfDates);
		})
	}

	setupOData() {

		this.selectedCompanyService.getCompanyIdObservable().subscribe(e => {
			this.companyService.getSingleCompany(e).subscribe(company => {
				if (!company.timezoneString) {
					Swal.fire({ icon: 'warning', title: 'The scheduler requires configuration before use', text: 'Please configure the timezone for the company in order to use the scheduler.' })
				}
				else {
					this.companyTimezone$.next(company.timezoneString);
					this.schedulerDisabled$.next(false);
					this.linkService.getLinkSchedulerInformation(this.usableLink.id, this.userConfig.showAllLinkSchedules).subscribe(listOfLinkSchedules => {


						//Configuration is linked to the schedule of THIS link, so we'll need to retrieve it for some configuration
						let currentLinkSchedulerInformation = listOfLinkSchedules.find(item => item.linkId == this.usableLink.id);

						this.linkSchedulerInformation = currentLinkSchedulerInformation;

						if(this.linkSchedulerInformation)
						{
							this.isSchedulerEnabled = currentLinkSchedulerInformation.isEnabled;
						}

						if(this.userConfig.showAllLinkSchedules)
						{
							//Clear before use
							this.appointments = [];

							listOfLinkSchedules.forEach(item => {
								if(item.isEnabled)
								{
									this.appointments.push({
									linkId: item.linkId,
									text: item.linkName,
									startDate: item.startDate,
									endDate: new Date(new Date(item.startDate).getTime() + 30 * 60000),
									recurrenceRule: item.recurrenceRule,
									disabled: true
									})
								}
							})
						}
						else if(this.linkSchedulerInformation.isEnabled)
						{
							this.appointments = [{
								linkId: this.usableLink.id,
								text: this.linkSchedulerInformation.linkName,
								startDate: this.linkSchedulerInformation.startDate,
								endDate: new Date(new Date(this.linkSchedulerInformation.startDate).getTime() + 30 * 60000),
								recurrenceRule: this.linkSchedulerInformation.recurrenceRule,
								disabled: true
							}]
						}
						else
						{
							this.appointments = [];
						}

						this.cdr.detectChanges();
					})

					this.getListOfDates();
				}
			})
		}).unsubscribe();
	}

	TransformDateToTimezone(date: Date) {
		let timeZone = date.toLocaleString("en-US", { timeZone: this.companyTimezone$.value });
		let timeZoneToSerialize = new Date(timeZone);
		return timeZoneToSerialize.toLocaleString();
	}

	getCurrentTimeZoneStringWithCompanyTimezone() {
		let timeZone = new Date().toLocaleString("en-US", { timeZone: this.companyTimezone$.value });
		let timeZoneToSerialize = new Date(timeZone);
		return timeZoneToSerialize.toLocaleString();
	}

	ngOnInit(): void {
		this.userConfig = this.userConfigService.getConfig();
		if(!this.userConfig)
		{
			this.userConfigService.setConfig({
				showAllLinkSchedules: true
			})

			this.userConfig = this.userConfigService.getConfig();
		}
		this.setupOData();
	}


	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
